<template>
<div>
  <div
    class="mb-1 px-5 text-right"
    v-if="advertisements.length > 1"
  >
    <!-- buttons -->
      <v-btn
        elevation="0"
        fab
        x-small
        @click="carouselIndex--, saveAnalitycsEvent(false)"
        :disabled="carouselIndex === 0"
      >
        <Icon
          :width="24"
          :color="'rgba(0,0,0,.54)'"
          :icon="'chevron-left'"
        />
      </v-btn>
      <v-btn
        elevation="0"
        fab
        x-small
        @click="carouselIndex++, saveAnalitycsEvent(true)"
        :disabled="(carouselIndex + 1) === advertisements.length"
        class="ml-2"
      >
        <Icon
          :width="24"
          :color="'rgba(0,0,0,.54)'"
          :icon="'chevron-right'"
        />
      </v-btn>
  </div>
  <!-- carrusel -->
  <div style="background: #333">
    <v-carousel
      hide-delimiters
      v-model="carouselIndex"
      :show-arrows="false"
      style="height: 50vw"
      @change="carouselEvent"
      :interval="intervalAd"
      :cycle="intervalAd ? true : false"
    >
      <v-carousel-item
        v-for="(advertisement, index) in advertisements"
        :key="`advertisement-${index}`"
      >
        <v-sheet tile style="height: 50vw">
          <div v-if="advertisement.advertisement_type === 'image'">
            <ImageAd
              :adItem="advertisement"
              :adIndex="index"
              @deleteIndex="deleteIndex"
              @goToAdvetisementLink="goToAdvetisementLink"
            />
          </div>
          <div v-else-if="advertisement.advertisement_type === 'video'">
            <VideoAd
              :adItem="advertisement"
              :playAd="carouselIndex === index"
              :adIndex="index"
              @deleteIndex="deleteIndex"
            />
          </div>
          <div v-else-if="advertisement.advertisement_type === 'youtube'">
            <Youtube
              :adItem="advertisement"
              :playAd="carouselIndex === index"
            />
          </div>
          <div v-else-if="advertisement.advertisement_type === 'embed'">
            <Embed
              :adItem="advertisement"
              :playAd="carouselIndex === index"
            />
          </div>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </div>
</div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    ImageAd: () => import(/* webpackPrefetch: true */ '@/views/advertisements/components/ImageAd.vue'),
    VideoAd: () => import(/* webpackPrefetch: true */ '@/views/advertisements/components/Video.vue'),
    Youtube: () => import(/* webpackPrefetch: true */ '@/views/advertisements/components/Youtube.vue'),
    Embed: () => import(/* webpackPrefetch: true */ '@/views/advertisements/components/Embed.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    advertisements: {
      type: Array,
      default: []
    }
  },
  watch: {
    'carouselIndex': function () {
      this.setActiveAd()
    }
  }
})
export default class Carrousel extends Vue {
  data () {
    return {
      carouselIndex: 0,
      activeAd: null,
      intervalAd: null
    }
  }

  mounted () {
    this.setActiveAd()
  }

  deleteIndex (index) {
    this.advertisements.splice(index, 1)
    this.setActiveAd()
  }

  setActiveAd () {
    this.activeAd = this.advertisements[this.carouselIndex]
    if (this.activeAd) {
      this.intervalAd = this.activeAd.visibility_time
      this.$emit('setActiveAd', this.activeAd)
    }
  }

  carouselEvent () {
    this.setActiveAd()
  }

  goToAdvetisementLink (advertisement) {
    this.$emit('goToAdvetisementLinkIndex', advertisement)
  }

  saveAnalitycsEvent (next) {
    const action = `Publicidad: ver ${next ? 'siguiente' : 'anterior'}`
    this.$ocularAnalitycs.widgetAnalitycsEvent({
      action,
      detail: 'El cliente interactuó con los anuncios',
      actionType: 'SVAH',
      functionality: 9,
      historyInteractionType: 'OSIFDV'
    })
  }
}
</script>

<style>
  .ad-design {
    width: 100%;
    max-width: 100% !important;
    height: 50vw;
  }
</style>
